import React from 'react';
import {
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Box,
  Typography,
  Autocomplete
} from '@mui/material';

const BlastScheduleConfig = ({
  schedule,
  onScheduleChange,
  timezones
}) => {
  const handleChange = (field, value) => {
    const updatedSchedule = {
      ...schedule,
      [field]: value
    };
    
    onScheduleChange(updatedSchedule);
  };

  // Transform timezones into objects with value and label properties
  const timezoneOptions = timezones.map(tz => ({
    value: tz,
    label: tz
  }));

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Autocomplete
          options={timezoneOptions}
          getOptionLabel={(option) => option.label}
          value={timezoneOptions.find(tz => tz.value === schedule.timezone) || null}
          onChange={(_, newValue) => {
            handleChange('timezone', newValue?.value || 'UTC');
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Timezone"
              required
              fullWidth
              error={!schedule.timezone}
              helperText={!schedule.timezone ? 'Timezone is required' : ''}
            />
          )}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          groupBy={(option) => option.value.split('/')[0]}
          renderGroup={(params) => (
            <li key={params.group}>
              <Box sx={{ 
                p: 1, 
                bgcolor: 'background.paper',
                borderBottom: '1px solid',
                borderColor: 'divider'
              }}>
                <Typography variant="subtitle2" color="text.secondary">
                  {params.group}
                </Typography>
              </Box>
              <ul style={{ padding: 0, margin: 0 }}>
                {params.children}
              </ul>
            </li>
          )}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          type="datetime-local"
          label="Send Time"
          value={schedule.send_time}
          onChange={(e) => handleChange('send_time', e.target.value)}
          InputLabelProps={{ shrink: true }}
          error={!schedule.send_time}
          helperText={!schedule.send_time ? "Send time is required" : ""}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControlLabel
          control={
            <Switch
              checked={schedule.business_hours_only}
              onChange={(e) => handleChange('business_hours_only', e.target.checked)}
            />
          }
          label="Business Hours Only"
        />
      </Grid>
    </Grid>
  );
};

export default BlastScheduleConfig; 